export const API_EXTERNAL_ENDPOINT = 'search/seo/destination/:destinationSlug'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/search/seo/destination'
